import { createPortal } from "react-dom";

interface ModalOverlayProps {
  onClick?: () => void;
}

export function ModalOverlay({ onClick }: ModalOverlayProps) {
  if (typeof document === "undefined") return null;
  return createPortal(
    <div
      aria-hidden="true"
      onClick={onClick}
      style={{
        position: "fixed",
        inset: 0,
        backgroundColor: "rgba(0, 26, 64, 0.48)",
        zIndex: 9999,
      }}
    />,
    document.body,
  );
}
